import {createFileRoute} from '@tanstack/react-router'
import AmericanosView_Create from "../../../americanos/AmericanosView_Create.tsx";

export const Route = createFileRoute('/_app/americanos/create')({
    component: RouteComponent,
})

function RouteComponent() {
    return <AmericanosView_Create />
}
